const normalizeTier = (value: unknown) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

const normalizeSubscriptionStatus = (value: unknown) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

const isStarterOrTrialToken = (value: string) => {
  if (!value) return true;
  if (value === "trial" || value === "starter" || value === "1") return true;
  const numeric = Number(value);
  if (Number.isFinite(numeric)) return numeric <= 1;
  return /\b(trial|starter)\b/.test(value);
};

export const isTrialLikeTier = (
  tier: unknown,
  subscriptionStatus?: unknown,
) => {
  const status = normalizeSubscriptionStatus(subscriptionStatus);
  if (status === "trialing") return true;
  if (status === "active") return false;
  const normalized = normalizeTier(tier);
  return isStarterOrTrialToken(normalized);
};

export const resolvePlanType = (
  tier: unknown,
  subscriptionStatus?: unknown,
): "trial" | "paid" =>
  isTrialLikeTier(tier, subscriptionStatus) ? "trial" : "paid";
